<ngx-extended-pdf-viewer *ngIf="NOMBREREPORTE !== undefined"
						 [src]="src"
						 useBrowserLocale="true" height="100vh">
</ngx-extended-pdf-viewer>
